document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-download]");
    if (!btn) return;

    const value = btn.getAttribute("data-download");
    if (!value) return;

    // Wait for the modal to open, then populate the hidden fields
    requestAnimationFrame(function () {
        const fields = window.tessellateDownloadFields || {};

        const fileField = document.querySelector(`[name="item_meta[${fields.file}]"]`);
        if (fileField) fileField.value = value;

        const referrerField = document.querySelector(`[name="item_meta[${fields.referrer}]"]`);
        if (referrerField) referrerField.value = window.location.href;
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const downloadModal = document.getElementById("modal-downloads-gated");
    const formContainer = document.getElementById("downloadModalGatedFormContainer");
    const originalFormHTML = formContainer ? formContainer.innerHTML : null;

    // Submit listener
    function attachSubmitListener() {
        const form = document.getElementById("form_downloads");
        if (!form) return;

        form.addEventListener("submit", function onFormSubmit() {
            const targetNode = formContainer;
            const config = { childList: true, subtree: true };

            let allowed = false;
            let trigger = true;

            const callback = (mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === "childList") {
                        for (const addedNode of mutation.addedNodes) {
                            if (addedNode.nodeType === 1) {
                                if (
                                    addedNode.classList.contains("frm_message") ||
                                    addedNode.querySelector(".frm_message")
                                ) {
                                    allowed = true;
                                }

                                if (allowed && trigger) {
                                    trigger = false;

                                    function getCookie(name) {
                                        const value = `; ${document.cookie}`;
                                        const parts = value.split(`; ${name}=`);
                                        return parts.length === 2 ? parts.pop().split(";").shift() : null;
                                    }

                                    function fromBase64(b64) {
                                        const bin = atob(b64);
                                        const bytes = new Uint8Array([...bin].map((c) => c.charCodeAt(0)));
                                        return new TextDecoder().decode(bytes);
                                    }

                                    const stored = getCookie("tessellateFile");
                                    if (stored) {
                                        const filename = fromBase64(decodeURIComponent(stored));
                                        const link = document.createElement("a");
                                        link.href = filename;
                                        link.setAttribute("download", "");
                                        document.body.appendChild(link);
                                        link.click();
                                        document.body.removeChild(link);
                                    }

                                    observer.disconnect();
                                }
                            }
                        }
                    }
                }
            };

            const observer = new MutationObserver(callback);
            if (targetNode) {
                observer.observe(targetNode, config);
            } else {
                console.error("The element with ID 'downloadModalGatedFormContainer' was not found.");
            }
        });
    }

    attachSubmitListener();

    // Modal listener just for setting the cookie
    if (downloadModal) {
        downloadModal.addEventListener("show.bs.modal", (event) => {
            const button = event.relatedTarget;
            const fileName = button.getAttribute("data-download");
            if (!fileName) return;

            function toBase64(str) {
                const bytes = new TextEncoder().encode(str);
                let bin = "";
                for (const b of bytes) bin += String.fromCharCode(b);
                return btoa(bin);
            }

            const obfuscated = toBase64(fileName);
            document.cookie = `tessellateFile=${encodeURIComponent(obfuscated)}; path=/; max-age=${60 * 60 * 24 * 7}`;
        });

        // Reset the form back to its original state on close, so it can be
        // submitted again the next time the modal is opened - Formidable's
        // AJAX success response replaces the form with a message in place
        // and never restores it.
        downloadModal.addEventListener("hidden.bs.modal", () => {
            if (formContainer && originalFormHTML) {
                formContainer.innerHTML = originalFormHTML;
                attachSubmitListener();

                // Formidable only auto-renders the Turnstile widget once, on
                // page load, via its Cloudflare onload callback. The reset
                // form HTML has an unrendered placeholder, so re-trigger it.
                if (typeof window.frmTurnstile === "function") {
                    window.frmTurnstile();
                }
            }
        });
    }
});
